const Signature = ({ className = "" }: { className?: string }) => (
  <span className={`signature font-script text-3xl text-primary ${className}`}>— Eliza</span>
);

export default Signature;
